export default __webpack_public_path__ + "a6143582309785dca6101e985d80cb3f.png";